var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"gantt-elastic",staticStyle:{"width":"100%"}},[_vm._t("header"),_c('main-view',{ref:"mainView"}),_vm._t("footer")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }